import { useEffect, useState } from "react";
import useFetch from "./fetchMSSQL-hook";

let _cache = null;
let _pending = null;

export default function useEvadtsDict() {
  const { fetchMssqlApi } = useFetch();
  const [state, setState] = useState(() => ({
    ready: !!_cache,
    byCode: _cache?.byCode || {},
    hintByPrefix: _cache?.hintByPrefix || {},
  }));

  useEffect(() => {
    if (_cache) return;
    if (!_pending) {
      _pending = new Promise((resolve, reject) => {
        fetchMssqlApi("kp/evadts/dict", { showLoader: false }, (res) => {
          _cache = res || {};
          setState({
            ready: true,
            byCode: _cache.byCode || {},
            hintByPrefix: _cache.hintByPrefix || {},
          });
          resolve(_cache);
        });
      });
    } else {
      _pending.then((res) =>
        setState({
          ready: true,
          byCode: res.byCode || {},
          hintByPrefix: res.hintByPrefix || {},
        })
      );
    }
  }, [fetchMssqlApi]);

  const getInfoByCode = (code) => {
    if (!code) return {};
    if (state.byCode[code]) return state.byCode[code];
    const prefix = code.slice(0, 3);
    const match = Object.keys(state.byCode).find((k) => k.startsWith(prefix));
    return match ? state.byCode[match] : {};
  };

    const getHintByCode = (code) => {
    if (!code) return "";
    const prefix = code.slice(0, 3);
    const hintText = state.hintByPrefix[prefix];
    if (!hintText) return "";

    const rows = hintText.split("\n").map((line) => {
        const parts = line
        .split("; ")
        .map((p) => p.replace(/^Kod: |Nazwa: |Opis: /, "").trim());
        return `
        <tr>
            <td class="border align-top text-nowrap px-2 py-1">${parts[0] || ""}</td>
            <td class="border align-top px-2 py-1">${parts[1] || ""}</td>
            <td class="border align-top px-2 py-1">${parts[2] || ""}</td>
        </tr>`;
    });

    return `
        <table class="table table-sm table-bordered table-hover mb-0 custom-scroll">
        <thead class="thead-light">
            <tr class="pe-none">
            <th scope="col" class="px-2 py-1">Kod</th>
            <th scope="col" class="px-2 py-1">Nazwa</th>
            <th scope="col" class="px-2 py-1">Opis</th>
            </tr>
        </thead>
        <tbody>
            ${rows.join("")}
        </tbody>
        </table>
    `;
    };

  return {
    ready: state.ready,
    getInfoByCode,
    getHintByCode,
  };
}
